export default __webpack_public_path__ + "static/last_report-d8ecb3a39898ddb0b79e088b298ffa02.svg";